<template>
  <span>
    <!-- <div class="columns">
      <div class="column is-12">
        <div class="box content">

          <h2 class="title is-4 custom_font">{{ $t('submit_claim.new_claim') }} <button class="button is-primary submit-claim" :disabled="isSubmitDisabled">   {{ $t('submit_claim.submit') }}  </button></h2>
          <h2 class="title is-4 custom_font">{{ $t('submit_claim.new_claim') }}</h2>

        </div>
      </div>
    </div> -->
    <div :key="gcFormKey" ref="gcFormContainer">
      <!-- <GeniusGCForm :upload-host="urls.FILE_UPLOAD_URL" :makes="makes" :models="models" :states="states" @submit="submitToPipeline" @getModels="getModels" /> -->
      <component
        :is="pageComponents.gcForm"
        :upload-host="urls.FILE_UPLOAD_URL"
        :claim-data="claimData"
        :template-id="$cgiSettings.templateId"
        :add-form="$cgiSettings.addForm"
        @submit="submitToPipeline"
        @getModels="getModels"
        @getVariants="getVariants"
        @getVehicleUid="getVehicleUid"
        @getVehicleYear="getVehicleYear"
      />
    </div>
  </span>
</template>
<script>
import urls from '../../../urls';

const _ = require('lodash');

export default {
  name: 'ClaimSubmit',
  data() {
    return {
      gcFormKey: '',
      claimData: {
        vinSelection: null,
        makes: [],
        models: [],
        states: [],
        years: [],
        bodyTypes: [],
        variants: [],
        cityCategories: [],
        paintTypes: [],
        uid: '-',
        allMakeModels: [],
        allData: [],
        loss_year: null,
        make: null,
        model: null,
        year: null,
        body: null,
        variant: null,
        cityCategory: null,
        paintType: null,
        state: null,
        bodyType: null,
        claimDetails: {
          state: null,
          images: [],
          loss_year: new Date(),
          registration_date: new Date(),
        },
      },
      urls,
      pageComponents: {
        gcForm: this.$cgiComponents.gcForm,
      },
    };
  },
  mounted() {
    this.loadDefaults();
  },
  methods: {
    async loadDefaults() {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      await Promise.all([this.getMakes(), this.getStates()]);
      this.gcFormKey = Math.random();
      loadingComponent.close();
    },
    async submitToPipeline(claimDetails) {
      const payload = JSON.parse(JSON.stringify(claimDetails));
      payload.country = window.localStorage.getItem('region');
      // payload.loss_year = '2019';
      payload.request_type = 'GC';
      payload.pipeline = 'genius-claim';
      const response = await this.$http.post('/202103/claims', payload);
      if (response) {
        this.$router.push({
          name: 'ClaimDetails',
          params: { claimUID: response.id },
        });
      }
    },
    async getStates() {
      this.claimData.states = await this.$http.get('meta/states');
    },
    async getMakes() {
      // this.makes = await this.$http.get('meta/makes');
      this.claimData.allMake = await this.$http.get('/202103/vehicles/makes');
      this.claimData.allMake = _.sortBy(this.claimData.allMake, (item) => item.make);
      if (this.claimData.allMake && this.claimData.allMake.length > 0) {
        this.claimData.makes = this.claimData.allMake.map((x) => ({
          value: x.make,
        }));
      }
    },
    async getModels(make) {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      this.claimData.allModel = await this.$http.get(
        `/202103/vehicles/models?make=${encodeURIComponent(make)}`,
      );
      this.claimData.allModel = _.sortBy(this.claimData.allModel, (item) => item.model);
      this.claimData.models = [];
      this.claimData.allData = [];
      this.claimData.variants = [];
      this.claimData.years = [];
      this.claimData.bodyTypes = [];
      if (this.claimData.allModel && this.claimData.allModel.length > 0) {
        this.claimData.models = this.claimData.allModel.map((x) => ({
          value: x.model,
        }));
      }
      loadingComponent.close();
    },
    async getVariants(data) {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      this.claimData.allData = [];
      this.claimData.variants = [];
      this.claimData.years = [];
      this.claimData.bodyTypes = [];
      this.claimData.allData = await this.$http.get(
        `/202103/vehicles/variants?make=${encodeURIComponent(data.make)}&model=${encodeURIComponent(
          data.model,
        )}`,
      );
      if (this.claimData.allData && this.claimData.allData.length > 0) {
        // this.claimData.variants = _.reject(this.claimData.allData, (o) => o.variant === null).map((x) => ({
        //   value: x.variant,
        // }));
        // this.claimData.years = _.reject(this.claimData.allData, (o) => o.year === null).map((x) => ({
        //   value: Number(x.year),
        // }));
        this.claimData.bodyTypes = _.reject(this.claimData.allData, (o) => o.body === null).map(
          (x) => ({
            value: x.body,
          }),
        );
      }
      // this.claimData.variants = _.uniqBy(this.claimData.variants, 'value');
      // this.claimData.variants = _.sortBy(this.claimData.variants, ['value']);
      this.claimData.years = _.uniqBy(this.claimData.years, 'value');
      this.claimData.years = _.sortBy(this.claimData.years, ['value']);
      this.claimData.bodyTypes = _.uniqBy(this.claimData.bodyTypes, 'value');
      this.claimData.bodyTypes = _.sortBy(this.claimData.bodyTypes, ['value']);
      if (this.claimData.bodyTypes.length === 1) {
        this.claimData.bodyType = this.claimData.bodyTypes[0].value;
        await this.getVehicleYear({
          make: data.make,
          model: data.model,
          bodyType: this.claimData.bodyType,
        });
      }
      loadingComponent.close();
    },
    async getCityCategories(vehicleUid) {
      // this.makes = await this.$http.get('meta/makes');
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      this.claimData.cityCategories = await this.$http.get(`/202103/city-categories/${vehicleUid}`);
      this.claimData.cityCategories = _.sortBy(
        this.claimData.cityCategories,
        (item) => item.city_category,
      );
      if (this.claimData.cityCategories && this.claimData.cityCategories.length > 0) {
        this.claimData.cityCategories = this.claimData.cityCategories
          .filter((a) => a.city_category !== null)
          .map((x) => ({
            value: x.city_category,
          }));
      }
      loadingComponent.close();
    },
    async getPaintTypes(vehicleUid) {
      // this.makes = await this.$http.get('meta/makes');
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      this.claimData.paintTypes = await this.$http.get(`/202103/paint-types/${vehicleUid}`);
      this.claimData.paintTypes = _.sortBy(this.claimData.paintTypes, (item) => item.paint_type);
      if (this.claimData.paintTypes && this.claimData.paintTypes.length > 0) {
        this.claimData.paintTypes = this.claimData.paintTypes
          .filter((a) => a.paint_type !== null)
          .map((x) => ({
            value: x.paint_type,
          }));
      }
      loadingComponent.close();
    },
    async getVehicleUid(data) {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      let uidData = null;
      if (data.make && data.model && data.year && data.bodyType && data.variant) {
        // const uidData = await this.$http.get(`/202103/vehicles/code?make=${data.make}&model=${data.model}&year=${data.year}&body=${data.bodyType}`);
        uidData = this.claimData.allData.find(
          (x) => x.make === data.make
            && x.model === data.model
            && x.year === data.year
            && x.body === data.bodyType
            && x.variant === data.variant,
        );
      } else if (data.make && data.model && data.year && data.bodyType) {
        uidData = this.claimData.allData.find(
          (x) => x.make === data.make
            && x.model === data.model
            && x.year === data.year
            && x.body === data.bodyType
            && x.variant === null,
        );
      }

      if (uidData) {
        this.claimData.uid = uidData.vehicle_code;
        // uidData.vehicle_code = 'MAHIRE8TOXXX2010SUVXXX';
        this.getPaintTypes(uidData.vehicle_code);
        this.getCityCategories(uidData.vehicle_code);
      }
      loadingComponent.close();
    },
    async getVehicleYear(data) {
      const loadingComponent = this.$buefy.loading.open({
        container: this.$refs.gcFormContainer.$el,
      });
      this.claimData.years = [];
      this.variants = [];
      let filteredData = [];
      if (this.claimData.allData && this.claimData.allData.length > 0) {
        filteredData = this.claimData.allData.filter(
          (x) => x.make === data.make && x.model === data.model && x.body === data.bodyType,
        );
        this.claimData.variants = _.reject(filteredData, (o) => o.variant === null).map((x) => ({
          value: x.variant,
        }));

        this.claimData.variants = _.uniqBy(this.claimData.variants, 'value');
        this.claimData.variants = _.sortBy(this.claimData.variants, ['value']);
        filteredData = [];
      }
      if (data.make && data.model && data.bodyType && data.variant) {
        filteredData = this.claimData.allData.filter(
          (x) => x.make === data.make
            && x.model === data.model
            && x.body === data.bodyType
            && x.variant === data.variant,
        );
      } else if (data.make && data.model && data.bodyType) {
        filteredData = this.claimData.allData.filter(
          (x) => x.make === data.make
            && x.model === data.model
            && x.body === data.bodyType
            && x.variant === null,
        );
      }
      if (filteredData && filteredData.length > 0) {
        this.claimData.years = _.reject(filteredData, (o) => o.year === null).map((x) => ({
          value: Number(x.year),
        }));
        this.claimData.years = _.uniqBy(this.claimData.years, 'value');
        this.claimData.years = _.reverse(_.sortBy(this.claimData.years, (item) => item.value));
      }
      loadingComponent.close();
    },
  },
};
</script>
